import { TbCash, TbChartPie, TbMathXDivideY2, TbPercentage, TbScale, TbStack2, TbSwitchVertical } from 'react-icons/tb';

export const BalanceSheetTabIcon = TbScale;
export const CapitalStructureTabIcon = TbStack2;
export const CashFlowsTabIcon = TbCash;
export const HoldingsTabIcon = TbChartPie;
export const IncomeStatementTabIcon = TbSwitchVertical;
export const MultiplesTabIcon = TbMathXDivideY2;
export const ReturnsTabIcon = TbPercentage;

export const financialTabIconMap = {
    balance: BalanceSheetTabIcon,
    'capital-structure': CapitalStructureTabIcon,
    cashflows: CashFlowsTabIcon,
    holdings: HoldingsTabIcon,
    income: IncomeStatementTabIcon,
    multiples: MultiplesTabIcon,
    returns: ReturnsTabIcon,
} as const;
